import { render, staticRenderFns } from "./ArticleRenameModal.vue?vue&type=template&id=5d08bd9f&"
import script from "./ArticleRenameModal.vue?vue&type=script&lang=js&"
export * from "./ArticleRenameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports